import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: '/',
	routes: [
		{
			path: '/',
			component: () => import('./views/Home.vue'),
			name: 'home',
		},
		{
			path: '/search',
			name: 'Search',
			component: () => import('./views/Search.vue')
		},
		{
			path: '/addDocument',
			name: 'addDocument',
			component: () => import('./views/AddDocument.vue')
		},
		{
			path: '/companyCard/:id',
			name: 'companyCard',
			component: () => import('./views/CompanyCard.vue')
		},
		{
			path: '/documentCard/:id',
			name: 'documentCard',
			component: () => import('./views/DocumentCard.vue')
		},
		{
			path: '/personeCard/:id',
			name: 'personeCard',
			component: () => import('./views/PersoneCard.vue')
		},
		{
			path: '*',
			component: () => import('./views/404.vue')
		}
	]
});

export default router;
